import Styled, { css } from 'styled-components';

import { IButtonProps } from '../Button';
import { BaseButtonStyles } from '../Button/BaseButton';
import { PrimaryActive, PrimaryDisabled } from '../Button/ButtonStyles';
import { SecondaryActive } from '../Button/SecondaryButton';

export const LinkButton = Styled.a<IButtonProps>`
  ${BaseButtonStyles};
  ${({ buttonStyle }) => buttonStyle === 'primary' && PrimaryActive};
  ${({ buttonStyle }) => buttonStyle === 'secondary' && SecondaryActive};
  ${({ disabled }) => disabled && css`
    ${PrimaryDisabled}

    &:hover {
      ${PrimaryDisabled}
    }
  `}

  text-decoration: none;
`;
